import React, {Component} from 'react';
import Spinner from '../generic/spinner';
import Parse from 'parse';
import Api from '../../Utils/api';
import _ from 'lodash';
import Utils from "../../Utils/Utility";
import CONFIG_HELPER from './../../../ConfigHelper';
import Actions from "../../actions";
import MainStore from '../stores/main-store';
import AddModifier from "./add-modifier";
import AddOptions from "./add-options";
import ReactDragListView from 'react-drag-listview';

export default class AddItem extends Component {

    static contextTypes = {
        router: React.PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            fields: {},
            errors: {},
            groups:null,
            itemOptionCategories:[],
            showAddModifierView:false,
            itemOptionData:{},
            selectedModifierRow:"",
            itemDetail:{},
            isLoaded: false,
            duplicateItem: false,
            duplicateModifier: false,
            showImageUploadForm: false,
            addItemView : false,
            showAddedItemInView : false
        }

        this._bind(
            'addNewModifier',
            'addItemModifiersAction',
            'showAddItemView',
            'updateItemModifiersAction',
            'duplicateItemModifiersAction',
            'removeItemModifiersAction',
            'loadAddedItemDetail',
            'renderImageUrlUpload'
        );
    }

    _bind(...methods) {
        methods.forEach((method) => this[method] = this[method].bind(this));
    }

    componentDidMount() {
        // when load the main class get all the data and reload
        this.loadItemDetail();
    }

    loadItemDetail(){

        let itemDetail    = this.state.itemDetail;
        let duplicateItem = this.state.duplicateItem;
        let fields        = this.state.fields;
        let itemOptionCategories = itemDetail.optionCategories;

        if (itemDetail && !Utils.isEmptyObj(itemDetail)){

            let itemName = itemDetail.itemName;
            let itemOptionCategoriesArray = [];

            if (duplicateItem){
                itemName = itemDetail.itemName + " COPY";
            }

            if (itemOptionCategories !== undefined){
                itemOptionCategoriesArray = itemOptionCategories;
            }

            this.setState({
                fields: {
                    name: itemName,
                    price: itemDetail.itemPrice,
                    description: itemDetail.itemDescription,
                    status: itemDetail.live == true ? 'online' : 'offline',
                    group: itemDetail.groupDetailPointer.objectId,
                    tax: itemDetail.itemTaxId ? itemDetail.itemTaxId : null,
                    imageTitle: itemDetail && itemDetail.mediaArray && itemDetail.mediaArray.length > 0
                        ? itemDetail.mediaArray[0] && itemDetail.mediaArray[0].name
                        : null,
                    mediaArray:  itemDetail.mediaArray  ? itemDetail.mediaArray : null
                },
                itemOptionCategories:itemDetail.optionCategories !== undefined ? itemDetail.optionCategories : [],
                // itemOptionCategories:itemDetail.optionCategories,
                isLoaded       : true
            });
        }
        else{

            this.setState({
                fields : {
                    status:'offline',
                },
                isLoaded       : true
            });
        }
    }


    loadAddedItemDetail() {
        let itemDetail = this.state.itemDetail;
        let duplicateItem = this.state.duplicateItem;
        let fields = this.state.fields;
        let name = fields["name"];
        let itemOptionCategories = itemDetail.optionCategories;
        let self = this;
        let mediaArray = fields["mediaArray"];

        if (Utils.isEmptyObj(itemDetail) && mediaArray == undefined) {

            let mediaArray = [];

            if(!Utils.isEmpty(name)){
                let appShortName = MainStore.getAppShortName();
                let name = fields["name"] ? Utils.removeSpecialCharsFromString(fields["name"]) : "";

                let awsURL = "https://s3-us-west-2.amazonaws.com/wlmerchants/"+appShortName+"/"+name+".jpg";

                let mediaJson = {
                    "url":awsURL,
                    "name":"",
                    "contentType":"image/jpeg",
                    "__type":"File",
                };

                mediaArray.push(mediaJson)

            }


            self.setState({
                fields: {
                    ...fields,
                    mediaArray: mediaArray,
                },
                showAddedItemInView : true
            });

        }
    }

    loadOptionCategories(optionCategories){

        let optionCategory = [];


        if (optionCategories && optionCategories.length > 0) {
            optionCategories.map((optCategory, i) => {

                let optionJSON = {};
                // console.log(item.optionCategoryName);
                optionJSON["optionCategoryName"] = optCategory.category;
                optionJSON["optionMinChoose"] = optCategory.minChoose;
                optionJSON["optionMaxChoose"] = optCategory.maxChoose;
                optionJSON["optionRequired"] = optCategory.required;
                optionJSON["isOptionQtyAllowed"] = optCategory.allowOptionQty == true ? 1 : 0;

                let opts = [];
                let itemOptions = optCategory.options;

                if (itemOptions && itemOptions.length > 0) {
                    itemOptions.map((itemOp, i) => {

                        let optionName = Object.keys(itemOp)[0];
                        let nestedJson = itemOp[optionName];

                        let optDesc = {};

                        optDesc['name'] = optionName;
                        optDesc["price"] = nestedJson.price;
                        optDesc["oos"] = nestedJson.oos;

                        opts.push(optDesc)

                    });
                }

                optionJSON["itemOptions"] = opts;

                optionCategory.push(optionJSON);

            });
        }

        return optionCategory;

    }

    componentWillMount() {

        this.setState({
            activeLocation: this.props.activeLocation,
            groups: this.props.groups,
            itemDetail: this.props.itemDetail,
            duplicateItem: this.props.duplicateItem,
            addItemView :  this.props.addItemView
        });
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps !== null) {
            this.setState({
                    // google: nextProps.google,
                    activeLocation: nextProps.activeLocation,
                    groups: nextProps.groups,
                    itemDetail: nextProps.itemDetail,
                    duplicateItem: nextProps.duplicateItem,
                    addItemView :  this.props.addItemView
                },
                () => {
                    this.loadItemDetail();
                });
        }
    }

    handleValidation(){
        let fields = this.state.fields;
        let errors = {};
        let formIsValid = true;

        //Name
        if(Utils.isEmpty(fields["name"]) || Utils.isEmptyWithTrim(fields["name"])){
            formIsValid = false;
            errors["name"] = "Cannot be empty";
        }

        // Only letters validation
        // if(typeof fields["name"] !== "undefined"){
        //     if(!fields["name"].match(/^[a-zA-Z]+$/)){
        //         formIsValid = false;
        //         errors["name"] = "Only letters";
        //     }
        // }

        //Price
        if(!fields["price"]){
            formIsValid = false;
            errors["price"] = "Cannot be empty";
        }

        if(typeof fields["price"] !== "undefined"){
            var validNumber = new RegExp(/^\d*\.?\d*$/);
            if (!validNumber.test(fields["price"])) {
                formIsValid = false;
                errors["price"] = "Price format is wrong. It must be a numerical value like $2.00";
            }
        }

        if(!fields["status"]){
            formIsValid = false;
            errors["status"] = "Cannot be empty";
        }


        if(!fields["group"]){
            formIsValid = false;
            errors["group"] = "Cannot be empty";
        }

        // if (MainStore.isItemTaxConfigured()){
        //     if(!fields["tax"]){
        //         formIsValid = false;
        //         errors["tax"] = "Cannot be empty";
        //     }
        // }

        this.setState({errors: errors});
        return formIsValid;
    }

   addFormSubmit(e){
        e.preventDefault();
        if(this.handleValidation()){

            let self = this;
            self.setState({
                isLoaded : false
            });

            let fields = this.state.fields;

            let status = false;
           if (fields["status"] == "online"){
               status = true;
           }

           let description = "";
           if(!Utils.isEmpty(fields["description"])){
               description = fields["description"];
           }


            let currentUser = Parse.User.current();
            // let userId = currentUser.id;
            // let sessionToken = currentUser.getSessionToken();
            let businessDetail = currentUser.get("bizId");
            let bizId = businessDetail.id;
            let itemDetail = this.state.itemDetail;
            const mediaArray = fields["mediaArray"] ?  fields["mediaArray"] : [];

            //remove empty image objects from mediaArray
            const options = mediaArray.filter(result => !Utils.isEmpty(result.url));

            // let mediaArray =
            var paramsObject = {
                "groupDetailPointer"    : Utils.getPointerFor("GroupDetail",fields["group"]),
                "bizId"                 : Utils.getPointerFor("BusinessDetail",bizId),
                "itemName"              : fields["name"],
                "itemPrice"             : _.round(fields["price"], 2),
                "live"                  : status,
                "itemDescription"       : description,
                "optionCategories"      : this.state.itemOptionCategories
            };


            let duplicateItem = this.state.duplicateItem;

            //Handle Media Array
            this.handleOptions(paramsObject, options);

            if (itemDetail && !Utils.isEmptyObj(itemDetail) && duplicateItem != true){
                 paramsObject["objectId"] = itemDetail.objectId;
                 // paramsObject["mediaArray"] = mediaArray;

                 // merge the existing data with current updated data
                paramsObject = {...itemDetail, ...paramsObject}

                // delete some special key
                delete paramsObject["ACL"];
                delete paramsObject["createdAt"];
                delete paramsObject["updatedAt"];

            }

            //If menu is not same across all location send locId in parameter
            if (MainStore.isMenuSameForAllLocationConfig() == false){
                paramsObject["locId"] = Utils.getPointerFor("LocationDetail",this.state.activeLocation.objectId);
            }

            if (MainStore.isItemTaxConfigured()){

                if (!Utils.isEmpty(fields["tax"])){
                    paramsObject["itemTaxId"] = Number(fields["tax"]);
                }
                else{
                    paramsObject["itemTaxId"] = {"__op" : "Delete"};
                }

            }

            console.log("paramsObject: " + JSON.stringify(paramsObject));

            this.saveItemToDatabase(paramsObject);
        }

    }

    // New function to handle options
    handleOptions(paramsObject, options) {
        if (options.length > 0) {
            paramsObject.mediaArray = options;
        } else {
            paramsObject.mediaArray = { "__op": "Delete" };
        }
    }

    // getItemOptionCategoriesJson() {
    //
    //
    //    var optionCategories = this.state.itemDetail.optionCategories;
    //
    //    console.log(optionCategories);
    //
    //     let jsonArray = [];
    //
    //     var itemOptionCategories = this.state.itemOptionCategories;
    //
    //     if (itemOptionCategories && itemOptionCategories.length > 0) {
    //
    //
    //         itemOptionCategories.map((item, i) => {
    //
    //             let optionJSON = {};
    //             // console.log(item.optionCategoryName);
    //             optionJSON["category"] = item.optionCategoryName;
    //             optionJSON["minChoose"] = item.optionMinChoose;
    //             optionJSON["maxChoose"] = item.optionMaxChoose;
    //             optionJSON["required"] = item.optionRequired;
    //             optionJSON["allowOptionQty"] = item.isOptionQtyAllowed == 1 ? true : false;
    //
    //             let opts = [];
    //             let itemOptions = item.itemOptions;
    //             itemOptions.map((itemOp, i) => {
    //
    //                 let optName = {};
    //                 let optDesc = {};
    //
    //                 optDesc["price"] = _.round(itemOp.price, 2);
    //                 optDesc["oos"] = itemOp.oos;
    //                 optName[itemOp.name] = optDesc;
    //
    //                 opts.push(optName)
    //
    //             });
    //             optionJSON["options"] = opts;
    //
    //             jsonArray.push(optionJSON);
    //
    //         });
    //     }
    //
    //     console.log(jsonArray);
    //
    //     optionCategories = {...optionCategories, ...jsonArray}
    //
    //     console.log(optionCategories)
    //
    //     return optionCategories
    // }

    saveItemToDatabase(params){

        let currentUser = Parse.User.current();
        let userId = currentUser.id;
        let sessionToken = currentUser.getSessionToken();
        let businessDetail = currentUser.get("bizId");
        let bizId = businessDetail.id;

        let itemDetail = this.state.itemDetail;
        let duplicateItem = this.state.duplicateItem;
        let isNew = true;
        if (itemDetail && !Utils.isEmptyObj(itemDetail) && duplicateItem != true){
         isNew = false;

        }

        let self = this;


        Api.updateItemDetail(isNew, userId, sessionToken, bizId, params)
            .then(
                (result) => {
                    const response = result.data;

                    self.setState({
                        isLoaded : true
                    });

                    self.props.callBackAfterUpdate();

                },
                (error) => {
                    Utils.checkErrorIsInvalidSessionToken(error, self.context.router);
                    this.setState({isLoaded : true });
                    console.log("Error occured while fetching latest user data!");
                }
            );

    }


    handleImageUrl(index, e) {
        const { value } = e.target;
        const { fields, addItemView } = this.state;

        const mediaArray = [...(fields.mediaArray || [])]; // Use a shallow copy

        if (mediaArray.length === 0) {
            const mediaJson = {
                url: value,
                name: "",
                contentType: "image/jpeg",
                __type: "File",
            };

            mediaArray.push(mediaJson);

        } else {
            // Update the specific element in the array immutably
            mediaArray[index] = { ...mediaArray[0], url: value };
        }

        this.setState({
            fields: {
                ...fields,
                mediaArray,
            },
        });
    }

    handleChange(field, e) {
        let fields = this.state.fields;
        let self = this;

        if (field === 'price') {
            let priceValue = e.target.value;
            let validNumber = new RegExp(/^\d*\.?\d*$/);
            if (!validNumber.test(priceValue)) {
                let error = "Price format is wrong. It must be a numerical value like $2.00";
                alert(error);
                let errors = {};
                errors["errors"] = error;
                this.setState({ errors: errors });
                return;
            }
        }

        fields[field] = e.target.value;
        this.setState({ fields });

        if (field === 'name') {
            //added to call the func
            //after 2 seconds of last keyStroke
            clearTimeout(this.timeoutId);  // Clear the previous timeout
            this.timeoutId = setTimeout(() => {
                self.loadAddedItemDetail();
            }, 2000);

        }
    }

    addNewModifier(){
        this.setState({
            showAddModifierView: true,
            itemOptionData : null,
            selectedModifierRow: null,
            duplicateModifier: false
        });
    }
    addItemModifiersAction(optionCategory, selectedModifierRow){

        let self = this;
        let opt = self.state.itemOptionCategories;

        if (selectedModifierRow == null){

            this.setState(prevState => ({
                itemOptionCategories: [...prevState.itemOptionCategories, optionCategory],
                showAddModifierView: false
            }));

        }
        else {

            // var itemOptionCategory = opt[selectedModifierRow];
            // itemOptionCategory.optionCategoryName = optionCategory.optionCategoryName;
            // itemOptionCategory.optionRequired = optionCategory.optionRequired;
            // itemOptionCategory.optionMinChoose = optionCategory.optionMinChoose;
            // itemOptionCategory.optionMaxChoose = optionCategory.optionMaxChoose;
            // itemOptionCategory.isOptionQtyAllowed = optionCategory.isOptionQtyAllowed;
            // itemOptionCategory.itemOptions = optionCategory.itemOptions;


            opt[selectedModifierRow] = optionCategory;

            self.setState({
                itemOptionCategories : opt,
                showAddModifierView: false
            });

        }

    }
    updateItemModifiersAction(selectedRow){

        let itemOptionCategories = this.state.itemOptionCategories;

        let itemOptionData = itemOptionCategories[selectedRow];

        this.setState({
            showAddModifierView: true,
            itemOptionData : itemOptionData,
            selectedModifierRow:selectedRow,
            duplicateModifier: false
        });


    }
    duplicateItemModifiersAction(selectedRow){

        let itemOptionCategories =  _.cloneDeep(this.state.itemOptionCategories);

        let itemOptionData = itemOptionCategories[selectedRow];

       // console.log(JSON.stringify(itemOptionData));

        this.setState({
            showAddModifierView: true,
            itemOptionData : itemOptionData,
            selectedModifierRow:null,
            duplicateModifier: true
        });

    }
    removeItemModifiersAction(selectedRow){

        let result = confirm("Are you sure you want to delete?");
        if (result) {
            const self = this;
            const itemOptionCategories = self.state.itemOptionCategories;

            itemOptionCategories.splice(selectedRow, 1);

            self.setState({itemOptionCategories},()=> {
                // self.props.callBackAddOptions(self.state.itemOptionCategories);
            });
        }
    }

    showAddItemView(){
        this.setState({
            showAddModifierView: false,
            itemOptionData : null,
            selectedModifierRow:null,
            duplicateModifier: false
        });
    }


    renderImageUrlUpload() {
        const { mediaArray } = this.state.fields;

        const renderImageInput = (index = 0) => {
            const mediaItem = mediaArray && mediaArray[index] ? mediaArray[index] : {}; // Check if mediaArray and mediaArray[index] are defined
            const labelContent = mediaArray && mediaArray.length > 1 ? `Image URL ${index + 1}` : "Image URL";

            return (
                <div className={`col-lg-${mediaArray && mediaArray.length > 1 ? "6" : "12"} pl-0`} key={index}>
                    <div className="form-group imageBox">
                        <label htmlFor={`imageUrl${index}`}>{labelContent}</label>
                        <input
                            type="text"
                            className="form-control"
                            name="imageUrl"
                            id={`imageUrl${index}`}
                            aria-describedby={`imageUrl${index}`}
                            placeholder={`Enter ${labelContent}`}
                            onChange={this.handleImageUrl.bind(this, index)}
                            value={mediaItem.url || ""}
                        />
                        {this.renderError("imageUrl")}
                    </div>
                </div>
            );
        };

        return (
            <div>
                {mediaArray && mediaArray.length > 0
                    ? mediaArray.map((_, index) => renderImageInput(index))
                    : renderImageInput()}
            </div>
        );
    }


    renderError(fieldName) {
        return (
            <span style={{ color: "red" }} className="form-text">
            {this.state.errors[fieldName]}
        </span>
        );
    }

    getImageContainerClass = () => {
        const { mediaArray } = this.state.fields;

        const baseClass = " col-lg-6 mb-10";
        const fullWidthClass = "col-lg-12 mb-10";

        return `imageContainer ${mediaArray && mediaArray.length > 1 ? fullWidthClass : baseClass}`;
    };

    render() {

        let groupsData = this.state.groups;

        let fields = this.state.fields;
        let mediaArray = fields["mediaArray"];

        let optionGroups = groupsData.map((group) =>
            <option key={group.objectId} value={group.objectId} >{group.groupName}</option>
        );


        let optionTaxs = '';
        if (MainStore.isItemTaxConfigured()){
         let taxConfig = MainStore.getItemTaxConfig();
            let taxRatesConfig = taxConfig.taxRates;

            optionTaxs = taxRatesConfig.map((tax) =>
                <option key={tax.id} value={tax.id}>{tax.name}({tax.rate}%)</option>
            );

        }

        const self = this;
        const dragPropsOptionCategories = {
            onDragEnd(fromIndex, toIndex) {

                const itemOptionCategories = [...self.state.itemOptionCategories];

                const modifierOption = itemOptionCategories.splice(fromIndex, 1)[0];

                itemOptionCategories.splice(toIndex, 0, modifierOption);
                self.setState({itemOptionCategories},()=> {
                    console.log(JSON.stringify(self.state.itemOptionCategories));
                    // self.props.callBackAddOptions(self.state.itemOptionCategories);
                });
            },
            handleSelector: 'a'
        };

        return (
            <div className="order-pg">
                {!this.state.isLoaded ? <Spinner/> : null}
                {
                    this.state.errors["errors"] ? (
                        <div className="alert alert-danger text-center" role="alert">
                            <span className="form-text">{this.state.errors["errors"]}</span>
                        </div>) : null

                }
                {
                    this.state.showAddModifierView ? (
                        <div>
                            <AddModifier
                                // activeLocation = {this.props.activeLocation}
                                callBackAddModifiers={this.addItemModifiersAction}
                                callBackParent={this.showAddItemView}
                                itemOptionData={this.state.itemOptionData}
                                selectedModifierRow={this.state.selectedModifierRow}
                                duplicateModifier={this.state.duplicateModifier}
                            />
                        </div>
                        ) : (
                        <div className="border-class marginTop">
                            <h3 id="translations" className="page-header">Add Item</h3>
                            {/*<div className="alert alert-danger text-center" role="alert">*/}
                            {/*Error is here you can connect with error proceed.*/}
                            {/*</div>*/}
                            <form name="addItemform" className="addItemform" onSubmit= {this.addFormSubmit.bind(this)}>
                                <div className="row form-group">
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label htmlFor="labelName">Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="name"
                                                ref="name"
                                                aria-describedby="name"
                                                placeholder="Enter name"
                                                onChange={(e) => this.handleChange("name", e)}
                                                value={this.state.fields["name"]}
                                            />
                                            <span style={{color: "red"}} className="form-text">{this.state.errors["name"]}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label htmlFor="labelPrice">Price</label>
                                            <input type="tel" className="form-control"
                                                   id="price" ref="price" pattern="^-?[0-9]\d*\.?\d*$"
                                                   placeholder="Enter Price" onChange={this.handleChange.bind(this, "price")} value={this.state.fields["price"]}/>
                                            {(
                                                this.state.errors["price"] ? (<span style={{color: "red"}} className="form-text">{this.state.errors["price"]}</span>) : (<small className="form-text text-muted">Note: Price should be a numerical value like 2.00</small>)

                                            )}

                                        </div>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="exampleInputDescription">Description</label>
                                    <textarea className="form-control" name="description" id="description" ref="description" rows="3"  placeholder="Description" onChange={this.handleChange.bind(this, "description")} value={this.state.fields["description"]}></textarea>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="exampleInputPassword1">Status</label>
                                    <div onChange={this.handleChange.bind(this, "status")}>
                                        <label className="radio-inline">
                                            <input type="radio" name="status" id="offline"
                                                   value="offline" checked={this.state.fields["status"] == 'offline'} /> Offline
                                        </label>
                                        <label className="radio-inline">
                                            <input type="radio" name="status" id="online"
                                                   value="online" checked={this.state.fields["status"] == 'online'} /> Online
                                        </label>
                                    </div>
                                    <span style={{color: "red"}} className="form-text">{this.state.errors["status"]}</span>
                                </div>

                                <div className="form-group col-lg-12 no-gutter">
                                    <label className={"d-block"} htmlFor="inputTax">Item Image URL</label>

                                    <div className={this.getImageContainerClass()}>
                                        {this.renderImageUrlUpload()}
                                    </div>
                                </div>

                                <div className="row form-group">
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label htmlFor="inputGroup">Group</label>
                                            <select id="group" className="form-control" onChange={this.handleChange.bind(this, "group")} value={fields['group']}>
                                                <option value={''}>Choose a Group</option>
                                                {optionGroups}
                                            </select>
                                        </div>
                                        <span style={{color: "red"}} className="form-text">{this.state.errors["group"]}</span>
                                    </div>
                                    {(
                                        MainStore.isItemTaxConfigured() ? (
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label htmlFor="inputTax">Tax</label>
                                                    <select id="tax" className="form-control" onChange={this.handleChange.bind(this, "tax")} value={fields['tax']}>
                                                        <option value={''}>Choose a Tax</option>
                                                        {optionTaxs}
                                                    </select>
                                                </div>
                                                <span style={{color: "red"}} className="form-text">{this.state.errors["tax"]}</span>
                                            </div>
                                        ) : null
                                    )}

                                </div>

                                <div className="form-group">
                                    <div className="col-lg-12 modifier-pg">
                                        <button type="button" className="btn btn-success btn-sm float-right" onClick={this.addNewModifier}><i className="fa fa-plus" aria-hidden="true"></i> Add Modifier
                                        </button>
                                        <h4 id="translations" className="page-header">Modifiers</h4>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="row">
                                            <div className="">
                                                <ReactDragListView {...dragPropsOptionCategories}>
                                                    <div className="table-bordered mb-20">
                                                        <table className="table table-striped"
                                                               id="table-holder-custom">
                                                            <thead>
                                                            <tr >
                                                                <th scope="col" className="table-col">#</th>
                                                                <th scope="col" className="table-col">Modifier Name</th>
                                                                <th scope="col" className="table-col">Action</th>
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                            {
                                                                this.state.itemOptionCategories.map((el, i) => (
                                                                    <tr key={i} className="table-tr">
                                                                        <td><a type="button" href="JavaScript:void(0);" className="btn-rearrange1"><i className="fa fa-bars" aria-hidden="true"></i></a>
                                                                        </td>
                                                                        {/*<td>{i+1}</td>*/}
                                                                        <td><a href="JavaScript:void(0);" onClick={_ => this.updateItemModifiersAction(i)}>{el.category}</a></td>
                                                                        <td>
                                                                            <div className="dropdown">
                                                                                <button className="dropbtn"><i className="fa fa-ellipsis-h fa-lg" aria-hidden="true"></i></button>
                                                                                <div className="dropdown-content">
                                                                                    <a href="JavaScript:void(0);" onClick={_ => this.updateItemModifiersAction(i)}>Update</a>
                                                                                    <a href="JavaScript:void(0);" onClick={_ => this.duplicateItemModifiersAction(i)}>Duplicate</a>
                                                                                    <a href="JavaScript:void(0);" onClick={_ => this.removeItemModifiersAction(i)}>Delete</a>
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                    </tr>))

                                                            }
                                                            </tbody>
                                                        </table>
                                                    </div>

                                                </ReactDragListView>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <button type="submit" className="btn btn-export">Save</button>
                                    <button type="submit" className="btn btn-default back-button" onClick={this.props.callBackParent} >Back</button>

                                </div>
                            </form>
                        </div>
                    )

                }

            </div>
        );
    }

}





// WEBPACK FOOTER //
// src/components/online-menu/add-item.js